import { addArea } from "../../../../../actions/Utilities/Area";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { addStateArea } from "../atoms/atoms";
import { useRecoilState } from "recoil";
import useSendEmail from "../../hooks/useSendEmail";

const useAddArea = () => {
  const queryClient = useQueryClient();
  const [, setActionAddState] = useRecoilState(addStateArea);
  const { mutateAsync: sendEmail } = useSendEmail();

  const { mutate } = useMutation((areaNewData) => addArea(areaNewData), {
    onSuccess: (res) => {
      if (res === "Duplicate") {
        toast.fire(
          "Saving Failed",
          "Area Name or Area Code already exists!",
          "warning"
        );
      } else {
        queryClient.invalidateQueries(["GetArea"]);
        sendEmail(res.data, {
          onSuccess: (res) => {
            if (res) {
              if (res.status === 400) {
                toast.fire(
                  "Success",
                  "Area Added Successfully, but failed in sending email",
                  "warning"
                );
              } else {
                toast.fire("Success", "Area Added Successfully", "success");
              }
            }
          },
        });
        setActionAddState(false);
      }
    },
    onError: () => {
      toast.fire("Failed", "Failed to Add Area!", "error");
    },
  });

  return mutate;
};
export default useAddArea;
